var _defs, _rect, _polygon, _polygon2, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAnthroper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e87b35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f0a060"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 112,
    fill: "#1a1410"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "108,400 196,400 256,168 220,168",
    fill: "url(#lg)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "256,168 292,168 352,400 264,400",
    fill: "url(#lg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 305,
    width: 140,
    height: 36,
    rx: 4,
    fill: "#1a1410"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 235,
    width: 38,
    height: 165,
    rx: 6,
    fill: "url(#lg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M389,270 C389,240 410,222 440,222 L440,258 C420,258 408,268 408,285",
    fill: "url(#lg)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAnthroper);
export default __webpack_public_path__ + "static/media/logo-anthroper.1cb490c1c44763ba03d02e768e53c621.svg";
export { ForwardRef as ReactComponent };